import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const AboutPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navbar />
      <main className="flex-grow">
        <div className="max-w-4xl mx-auto px-6 py-12 bg-white min-h-screen">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 pb-4 border-b border-gray-200">About ChatHub India</h1>
          
          <p className="text-base text-gray-600 leading-relaxed mb-6">
            Connect with strangers from Mumbai, Delhi, Bangalore, Hyderabad, and across India instantly. No Login Required.
          </p>

          <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Welcome to ChatHub India</h2>
          <p className="text-base text-gray-600 leading-relaxed mb-6">
            Welcome to <strong className="font-semibold text-gray-900">ChatHub India</strong>, the ultimate platform to meet new people and make friends online.
            Whether you are looking for a casual conversation, a new friend, or just want to kill boredom,
            our platform connects you with random strangers in seconds.
          </p>

          <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Why We Are the Best Alternative</h2>
          <ul className="list-disc list-outside ml-6 mb-6 text-gray-600 space-y-2">
            <li className="pl-2"><strong className="font-semibold text-gray-900">No Registration Needed:</strong> Start chatting immediately. We don't ask for phone numbers, or passwords.</li>
            <li className="pl-2"><strong className="font-semibold text-gray-900">Regional Communities:</strong> Find users who speak your language. From <strong className="font-semibold text-gray-900">Telugu Chat</strong> and <strong className="font-semibold text-gray-900">Tamil Chat</strong> to <strong className="font-semibold text-gray-900">Hindi</strong> and <strong className="font-semibold text-gray-900">Malayalam</strong> conversations, we bring India together.</li>
            <li className="pl-2"><strong className="font-semibold text-gray-900">100% Anonymous & Safe:</strong> Your identity is hidden. Chat freely without worrying about your personal data.</li>
            <li className="pl-2"><strong className="font-semibold text-gray-900">Video & Text Options:</strong> Choose how you want to interact. Use our high-quality text chat for privacy.</li>
          </ul>

          <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Our Mission</h2>
          <p className="text-base text-gray-600 leading-relaxed mb-6">
            To provide a safe, fun, and free environment for Indians to talk to strangers. We strictly enforce our
            <Link to="/terms-of-service" className="text-blue-600 hover:underline"> Terms of Service</Link> to keep the platform clean and strictly 18+.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;

